import clsx from 'clsx'
import type { FunctionComponent, ReactNode } from 'react'
import styles from './ColorUnderline.module.sass'
import { Icon } from './Icon'

const archedUrl = '/arched.svg'

const defaultColorUnderlineType = {
	underline1: 'linear',
	underline2: 'arched',
	underline3: 'wave',
	underline4: 'zigzag',
} as const
type DefaultColorUnderline = (typeof defaultColorUnderlineType)[keyof typeof defaultColorUnderlineType]

export type ColorUnderlineElement = {
	type: 'colorUnderline'
	suchThat: {
		colorUnderlineType: DefaultColorUnderline
	}
}

export type ColorUnderlineTextProps = {
	colorUnderlineType: DefaultColorUnderline
	children: ReactNode
}

export const ColorUnderlineText: FunctionComponent<ColorUnderlineTextProps> = ({ colorUnderlineType, children }) => {
	return (
		<span className={clsx(styles.wrapper, styles[`is_${colorUnderlineType}`])}>
			<span className={styles.content}>{children}</span>
			{colorUnderlineType === 'linear' ? (
				<span className={styles.highlight}>
					<Icon name="pencilUnderline" preserveAspectRatio={false} />
				</span>
			) : colorUnderlineType === 'wave' ? (
				<span className={styles.highlight}>
					<Icon name="rainbowWave" preserveAspectRatio={false} />
				</span>
			) : colorUnderlineType === 'zigzag' ? (
				<span className={styles.highlight}>
					<Icon name="dashedArrow" preserveAspectRatio={false} />
				</span>
			) : colorUnderlineType === 'arched' ? (
				<span className={styles.highlight}>
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img src={archedUrl} alt="" />
				</span>
			) : null}
		</span>
	)
}
